/**
 * Calls a Firebase Callable Function API endpoint.
 *
 * @param {string} functionName - The name of the Firebase function to call (e.g., 'getUserProfile').
 * @param {object} data - The JSON data payload to send to the function.
 * @param {object} headers - Additional HTTP headers to include (e.g., for Authorization).
 * @returns {Promise<Response>} The raw fetch Response object.
 */
async function firebase(functionName, data, headers = {}) {

  const API = {
    sendEmail: 'https://workflow.tuchsoft.com/webhook/sendEmail',
    subscribe: 'https://workflow.tuchsoft.com/webhook/subscribe',
    moodleVersion: 'https://workflow.tuchsoft.com/webhook/moodleVersion'
  };
  const KEY = "WTJsaGJ5QmlaV3hzWVN3Z2FXOGdkR2tnWTI5dWIzTmpieUIwZFNCbWR";

  let url = API[functionName];
  if (false) {//FIXME
    url = 'http://127.0.0.1:5001/tuchsoft-generic/europe-west1/'+functionName;
  }

    try {
    const response = await fetch(url, {
      method: 'POST',
                  headers: {
        'Content-Type': 'application/json',
         'X-Tuchsoft-Key': KEY,
        ...headers,       },
      body: JSON.stringify(data),
    });

    return response;

  } catch (error) {
        console.error(`Error calling Firebase function '${functionName}':`, error);
        throw error;
  }
}